var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1279.997,
    height: 1279.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 13333.33 13333.33",
    id: "instagram-logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9425.49,
    x2: 3907.84,
    y1: 1689.61,
    y2: 11643.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4845a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#a844a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#a844a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#a844a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d7233e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d7233e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#f8a325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd25"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13333.33,
    height: 13333.33,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M4365.91 2471.84l4601.52 0c1029.13,0 1869.24,842.02 1869.24,1869.25l0 4649.24c0,1029.14 -840.11,1871.15 -1869.24,1871.15l-4601.52 0c-1027.22,0 -1869.24,-842.02 -1869.24,-1871.15l0 -4649.24c0,-1027.23 842.02,-1869.25 1869.24,-1869.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8196.04 3877.12l-3058.76 0c-683.54,0 -1242.98,559.44 -1242.98,1242.98l0 3091.22c0,683.55 559.43,1242.98 1242.98,1242.98l3058.76 0c683.55,0 1242.98,-559.44 1242.98,-1242.98l0 -3091.22c0,-683.55 -559.44,-1242.98 -1242.98,-1242.98zm729.37 4047.8l0 0c0,555.62 -456.33,1011.95 -1011.95,1011.95l-2491.69 0c-557.53,0 -1011.95,-456.33 -1011.95,-1011.95l0 -2516.51c0,-557.53 454.42,-1011.95 1011.95,-1011.95l2491.69 0c555.62,0 1011.95,454.42 1011.95,1011.95l0 2516.51z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M6666.67 5290.03c-758.01,0 -1374.73,618.63 -1374.73,1376.63 0,758.01 616.72,1374.73 1374.73,1374.73 758.01,0 1376.63,-616.72 1376.63,-1374.73 0,-758.01 -618.62,-1376.63 -1376.63,-1376.63zm0 2287.39l0 0c-502.16,0 -910.76,-408.6 -910.76,-910.76 0,-502.16 408.6,-910.75 910.76,-910.75 502.15,0 910.75,408.59 910.75,910.75 0,502.16 -408.6,910.76 -910.75,910.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9436.86 3868.69c156.57,0 282.58,-126.02 282.58,-280.67 0,-156.56 -126.02,-282.58 -282.58,-282.58 -154.66,0 -280.67,126.02 -280.67,282.58 0,154.66 126.02,280.67 280.67,280.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.b4910ebb843d8e2af9ccc844bc9a38c4.svg";
export { ForwardRef as ReactComponent };